import React from "react";
import { Link } from "react-router-dom";
import { FaChevronRight } from "react-icons/fa";
import SuperAdminStorageService from "../../services/SuperAdminStorageService";
import {
  SUPER_ADMIN_MASTER_DATA_ITEMS,
  SUPER_ADMIN_P2P_ITEMS,
} from "../../config/superAdminNavigation";
import "../../assets/styles/master_category_admin.scss";
import "../../assets/styles/super_admin.scss";

export default function SuperAdminDashboardPage() {
  const admin = SuperAdminStorageService.getAdmin();

  return (
    <div className="mca-page super-admin-page">
      <nav className="mca-breadcrumb" aria-label="Breadcrumb">
        <ol className="mca-breadcrumb__list">
          <li aria-current="page">Super Admin</li>
        </ol>
      </nav>

      <header className="mca-hero">
        <div>
          <div className="mca-hero__title-row">
            <h1 className="mca-hero__title">
              Welcome{admin?.full_name ? `, ${admin.full_name}` : ""}
            </h1>
            <span className="mca-hero__badge">Super Admin</span>
          </div>
          <p className="mca-hero__subtitle">
            Manage platform master data and Procure-to-Pay (P2P) administration.
          </p>
        </div>
      </header>

      <section className="mca-card">
        <h2 className="mca-section-title">Master Data</h2>
        <div className="sa-module-grid">
          {SUPER_ADMIN_MASTER_DATA_ITEMS.map((item) => {
            const Icon = item.icon;
            return (
              <Link key={item.id} to={item.to} className="sa-module-tile">
                <span className="sa-module-tile__icon" aria-hidden>
                  <Icon />
                </span>
                <div className="sa-module-tile__body">
                  <h3>{item.label}</h3>
                </div>
                <FaChevronRight className="sa-module-tile__arrow" aria-hidden />
              </Link>
            );
          })}
        </div>
      </section>

      <section className="mca-card">
        <h2 className="mca-section-title">Procure-to-Pay</h2>
        <div className="sa-module-grid">
          {SUPER_ADMIN_P2P_ITEMS.map((item) => {
            const Icon = item.icon;
            return (
              <Link key={item.id} to={item.to} className="sa-module-tile">
                <span className="sa-module-tile__icon" aria-hidden>
                  <Icon />
                </span>
                <div className="sa-module-tile__body">
                  <h3>{item.label}</h3>
                </div>
                <FaChevronRight className="sa-module-tile__arrow" aria-hidden />
              </Link>
            );
          })}
        </div>
      </section>
    </div>
  );
}
